module.exports = __webpack_public_path__ + "img/czech-republic.1d4cf2eb.svg";